export const findClosestNumber = (target: number, array: number[]) => {
	const indexArr = array.map((num) => {
		return Math.abs(num - target);
	});
	const min = Math.min(...indexArr);
	return array[indexArr.indexOf(min)];
};
